<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VOUgSB/Images/MSRCover.jpg?1717895406062" alt="This image is the cover for the book Nominee"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nominee
      </h1>
      <p class="bookDescription body article font2">
        <b>Washington press insider Brian McGrory, whose debut novel, <i>The Incumbent,</i> soared onto the national bestseller lists amid rave reviews, is back with a second sizzling political thriller featuring Jack Flynn, the intrepid newspaperman with the wry turn of phrase.</b><br/><br/> News is crackling all around him when Jack Flynn, ace reporter for <i>The Boston Record,</i> is summoned to a secret meeting with his esteemed publisher, Paul Ellis. Ellis sadly reveals that the newspaper they both love, owned by his family for more than a century, is the target of a hostile takeover bid by a shadowy corporate chain. Desperate, he asks for Jack's help. <br/> Already on the brink of a hot political scoop, Jack sets out in pursuit of a hidden truth. But that very day his life is threatened. <i>The Record</i> is beset by horrific tragedy. And a death from years ago no longer appears what it once seemed. <br/> Now Jack is forced to question not only the words published in his own paper but the relationships that have been the bedrock of his life -- in particular those with his gorgeous ex-girlfriend, who writes for a rival tabloid, and with the venerable <i>Record</i> reporter Robert Fitzgerald, Jack's longtime mentor. <br/> And all along, Jack is sitting on a goldmine of information that could torpedo the president's controversial nomination of the Massachusetts governor to be the next U.S. Attorney General. As he balances on a tightrope of personal and professional peril, shuttling from the swamps of central Florida to the corridors of Congress, then back to the alleyways of Boston, Jack is left with just two questions: Will his newspaper survive long enough for him to tell his story? Will he? <br/> Combining breakneck speed and tension-packed plotting with the insights of a consummate political insider, Brian McGrory explores the ethics and direction of modern journalism and analyzes how, in this era of media saturation, reputations are made and too often destroyed. <i>The Nominee,</i> peopled with irresistible characters that linger long after the last page is turned, confirms his position at the forefront of today's most talented young suspense writers.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian McGrory
      </h2>
      
      <p class="authorDescription body article"><B>Brian McGrory</B> was a roving national reporter for the <I>Boston Globe,</I> as well as the <I>Globe's</I> White House correspondent during the Clinton administration. He is now a columnist in the newspaper's Metro section. The author of three bestselling thrillers -- <I>The Incumbent, The Nominee,</I> and <I>Dead Line</I> -- he lives in Boston. Find out more at www.brianmcgrory.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atria
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?567ce4b4